import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom'

import * as analytics from '../utils/ga4';

export function useAnalytics() {
  const location = useLocation()
  const { user, isAuth, fetchAuthFinish } = useSelector(state => state.auth);
  const [initGaUser, setInitGaUser] = useState();

  useEffect(() => {
    if (fetchAuthFinish) {
      analytics.init();
    }
  }, [fetchAuthFinish])

  useEffect(() => {
    let userPsaudoId;
    try {
       userPsaudoId =document.cookie.split(";").filter(c=>c.startsWith("_ga=GA1.1."))[0].replace("_ga=GA1.1.","")
    }
    catch (e){}
    
    if (isAuth === true) {
      analytics.setUser({
        exidentifier: user.exidentifier,
        student_kita: user.studentkita || "-",
        student_makbila: user.studentmakbila || "-",
        student_mosad: user.studentmosad || "-",
        isstudent: user.isstudent,
        userPsaudoId:userPsaudoId
      })
      setInitGaUser(true)
    }
    else if (isAuth === false) {
      analytics.setUser({
        exidentifier: "-",
        student_kita: "-",
        student_makbila: "-",
        student_mosad: "-",
        isstudent: "-",
        userPsaudoId:userPsaudoId
      })
      setInitGaUser(true)
    }
  }, [user, isAuth])

  useEffect(() => {
    if (initGaUser) {
      const path = location.pathname + location.search
      analytics.sendPageview(path)
    }
  }, [location, initGaUser])
}

export default useAnalytics